import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Mission from './pages/Mission';
import Gallery from './pages/Gallery';
import Bidra from './pages/Bidra';
import Anmalan from './pages/Anmalan';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/bidra" element={<Bidra />} />
          <Route path="/anmalan" element={<Anmalan />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
